<template>
  <div :class="{ 'toolbar': true, 'is-sticky': isSticky }">
    <div :class="{ 'toolbar-wrapper': true, 'mt-0': !title }">
      <d-button
        v-if="!hideBackButton"
        outline
        theme="secondary"
        @click.prevent="goBack">
        <i class="material-icons">arrow_back_ios</i>
        Back
      </d-button>

      <h2
        v-if="title"
        class="toolbar-title">
        {{ title }}
      </h2>

      <div :class="{
        'operations': true,
        'w-100': !title
      }">
        <d-button
          v-if="actionButtonLabel"
          theme="primary"
          class="ml-2"
          @click.prevent="actionButtonCallback()">
          <i class="material-icons">{{ actionButtonIcon }}</i>
          {{ actionButtonLabel }}
        </d-button>

        <d-button
          v-if="addButtonLabel"
          theme="success"
          class="ml-2"
          @click.prevent="$router.push(addButtonRoute)">
          <i class="material-icons">add_circle_outline</i>
          {{ addButtonLabel }}
        </d-button>

        <d-button
          v-if="saveButtonLabel"
          theme="success"
          :class="{
            'ml-2': title,
            'w-100': !title
          }"
          :disabled="saveInProgress"
          @click.prevent="$bus.$emit(saveButtonEvent)">
          <i class="material-icons">save</i>
          {{ saveButtonLabel }}
        </d-button>

        <d-button
          v-if="deleteButtonLabel"
          theme="danger"
          class="ml-2"
          :disabled="deleteInProgress"
          @click.prevent="$bus.$emit(deleteButtonEvent)">
          <i class="material-icons">delete</i>
          {{ deleteButtonLabel }}
        </d-button>
      </div>

      <div class="additional-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Toolbar',
  props: [
    'hideBackButton',
    'isSticky',
    'backRoute',
    'beforeBack',
    'title',
    'actionButtonLabel',
    'actionButtonCallback',
    'actionButtonIcon',
    'addButtonLabel',
    'addButtonRoute',
    'deleteButtonLabel',
    'deleteButtonEvent',
    'saveButtonLabel',
    'saveButtonEvent',
    'deleteInProgress',
    'saveInProgress'
  ],
  methods: {
    goBack () {
      if (this.beforeBack) {
        this.beforeBack(() => {
          if (this.backRoute === -1) {
            this.$router.go(-1);
          } else {
            this.$router.push(this.backRoute);
          }
        });

        return;
      }

      if (this.backRoute === -1) {
        this.$router.go(-1);
      } else {
        this.$router.push(this.backRoute);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar {
  position: relative;

  &-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin: 30px auto 20px auto;
    max-width: 1180px;
    position: relative;

    & > .btn,
    & > .operations {
      left: 0;
      position: absolute;
      top: 0;
    }

    & > .operations {
      left: auto;
      right: 0;
    }

    .additional-content {
      width: 100%;
    }
  }

  &-title {
    font-size: 32px;
    margin: 0;
    text-align: center;
    width: 100%;
  }

  &.is-sticky {
    background: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, .25);
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10;
  }
}
</style>
